export const GOOGLE_MAP_KEY = "AIzaSyALsW9JNLCEwvvbzJawl1turdvLnt3nKPo";
